import { appealDataRequestLoadingSelector } from '../../store/appealDataRequest/selectors';
import { createStructuredSelector } from 'reselect';

import {
  appealAgreementOnSelector,
  currentExamSelector
} from '../../store/examData/selectors';
import { completeSTEP4Selector } from '../../store/step/selectors';

const stepAgreementSelector = createStructuredSelector({
  loading: appealDataRequestLoadingSelector,
  agreementOn: appealAgreementOnSelector,
  stepCompleteSTEP4: completeSTEP4Selector,
  currentExam: currentExamSelector
});

export default stepAgreementSelector;
